import { render } from "./TemplateModalPopup.vue?vue&type=template&id=b5227d58&scoped=true&ts=true"
import script from "./TemplateModalPopup.vue?vue&type=script&lang=ts"
export * from "./TemplateModalPopup.vue?vue&type=script&lang=ts"

import "./TemplateModalPopup.vue?vue&type=style&index=0&id=b5227d58&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5227d58"]])

export default __exports__